// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"b33c71a3","72":"77914ffd","75":"b8ad04f1","197":"4b1085f8","294":"879b94b5","390":"367e6f1b","681":"dd63b4bb","997":"3fa48a91"}[chunkId] + ".chunk.js";
};